import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography
} from '@material-ui/core'
import { Form, Formik } from 'formik'
import * as yup from 'yup'

import DropzoneInput from 'src/components/DropzoneInput'
import { syncPessoas } from '../hooks/pessoasRepository'
import snackbarStore from 'src/stores/snackbar'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

type FormValues = {
  file: File[] | undefined
}

const initialValues: FormValues = {
  file: undefined
}

const schema = yup.object().shape({
  file: yup
    .array()
    .required('Arquivo CSV é obrigatório')
    .min(1, 'Arquivo CSV é obrigatório')
})

export function SincronizarDialog({ isOpen, handleClose }: Props) {
  async function handleSubmit(values: FormValues) {
    try {
      const file = values.file?.[0]

      if (!file) {
        return
      }

      await syncPessoas(file)

      snackbarStore.setMessage('Sincronização realizada com sucesso.')

      handleClose()
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        'Erro ao sincronizar pessoas.'

      snackbarStore.setMessage(message)

      console.error(error)
    }
  }

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      aria-describedby="form-dialog-description"
      fullWidth
      maxWidth="sm"
    >
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <DialogTitle>Sincronizar Pessoas - Rodopar</DialogTitle>

            <DialogContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant="body1">
                    Deseja sincronizar as pessoas com a Rodopar?
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <DropzoneInput
                    name="file"
                    fileLimit={1}
                    acceptedFiles={['.csv']}
                    dropzoneTitle="CSV Pessoas Rodopar"
                    disabled={isSubmitting}
                  />
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions>
              <Button
                variant="outlined"
                onClick={handleClose}
                disabled={isSubmitting}
              >
                Cancelar
              </Button>

              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isSubmitting}
              >
                Sincronizar
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}
